import { useTranslation } from 'react-i18next';

import { EmptyStarred } from '../empty-starred/EmptyStarred';
import { HistoryPill } from '../history-pill/HistoryPill';
import { CategoryType } from '../history-sidebar/HistorySidebar';
import { Conversation } from '../use-chat/use-chat.types';
import styles from './HistoryGroup.module.scss';

export const orderedGroupTypes = [
  'today',
  'yesterday',
  'twoDaysAgo',
  'thisWeek',
  'older',
];

export type GroupTypes = 'starred' | (typeof orderedGroupTypes)[number];

interface HistoryGroupProps {
  groupType: GroupTypes;
  conversations: Conversation[];
  category: CategoryType;
  handleOpenSharingModal: () => void;
}

export const HistoryGroup = ({
  groupType,
  conversations,
  category,
  handleOpenSharingModal,
}: HistoryGroupProps) => {
  const { t } = useTranslation(['chat']);
  const isStarredGroup = groupType === 'starred';

  const renderContent = () => {
    if (isStarredGroup && !conversations.length) {
      return <EmptyStarred />;
    }

    return conversations.map(conversation => {
      return (
        <HistoryPill
          key={conversation.id}
          conversation={conversation}
          category={category}
          handleOpenSharingModal={handleOpenSharingModal}
        />
      );
    });
  };

  const renderLabel = () => {
    if (isStarredGroup && !conversations.length) {
      return null;
    }

    return (
      <h4 className={styles.label}>
        {/* i18next-extract-mark-context-next-line ["starred", "today", "yesterday", "twoDaysAgo", "thisWeek", "older"]  */}
        {t('chat:historyTab.labels', {
          context: groupType,
          count: conversations.length,
        })}
      </h4>
    );
  };

  return (
    <div>
      {renderLabel()}
      {renderContent()}
    </div>
  );
};
